import { STRENGTHS } from '@src/const/password';

// 強：包含大小寫英文、數字、特殊符號，至少 8 碼
const strongRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})');

// 中等（好）：包含大小寫英文、數字，至少 8 碼
const mediumRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})');

export const isStrongPassword = password => strongRegex.test(password);

export const isMediumPassword = password => mediumRegex.test(password);

export const getPasswordStrength = (password = '') => {
  if (isStrongPassword(password)) {
    return STRENGTHS[0];
  } else if (isMediumPassword(password)) {
    return STRENGTHS[1];
  }

  return STRENGTHS[2];
}
